import { Toaster } from "ui-widgets";
import AuthService from "./AuthService";
import BoundaryOrPoint from "models/explorer/boundary-or-point";

export default class ExplorerService {
  public readonly explorerService = {
    boundary_search: async (
      boundary_guid: string,
      intersecting_or_contains: "intersecting" | "contains",
      tags: string[],
    ) => {
      const params = new URLSearchParams({
        boundary_guid,
        intersecting_or_contains,
        tags: JSON.stringify(tags),
      }).toString();
      const r = await fetch(
        `${process.env.REACT_APP_API_HOST}/explorer/boundarysearch?${params}`,
        {
          method: "GET",
          headers: AuthService.siteletHeaders,
          credentials: "include",
        },
      );
      if (r.ok) {
        const resp = await r.json();

        if (resp?.errors) {
          Toaster.makeToast("Error on query", "error");
        }
        return resp;
      } else if (r.status === 401) {
        // this.UserReset();
      }
    },
    polysearch: async (
      geojson: string,
      intersecting_or_contains: "intersecting" | "contains",
      tags: string[],
    ) => {
      const params = new URLSearchParams({
        geojson,
        intersecting_or_contains,
        tags: JSON.stringify(tags),
      }).toString();
      const r = await fetch(
        `${process.env.REACT_APP_API_HOST}/explorer/polysearch?${params}`,
        {
          method: "GET",
          headers: AuthService.siteletHeaders,
          credentials: "include",
        },
      );
      if (r.ok) {
        const resp = await r.json();

        if (resp?.errors) {
          Toaster.makeToast("Error on query", "error");
        }
        return resp;
      } else if (r.status === 401) {
        // this.UserReset();
      }
    },
    circleSearch: async (
      latitude: number,
      longitude: number,
      radius: number,
      tags: string[],
    ) => {
      const params = new URLSearchParams({
        latitude: latitude.toString(),
        longitude: longitude.toString(),
        radius: radius.toString(),
        tags: JSON.stringify(tags),
      }).toString();
      const r = await fetch(
        `${process.env.REACT_APP_API_HOST}/explorer/circlesearch?${params}`,
        {
          method: "GET",
          headers: AuthService.siteletHeaders,
          credentials: "include",
        },
      );
      if (r.ok) {
        const resp = await r.json();

        if (resp?.errors) {
          Toaster.makeToast("Error on query", "error");
        }
        return resp;
      } else if (r.status === 401) {
        // this.UserReset();
      }
    },
    boundaryPointSearch: async (
      search_term: string = "",
      limit: number = 50,
      signal?: AbortSignal,
    ): Promise<BoundaryOrPoint[] | undefined> => {
      const params = new URLSearchParams({
        search_term,
        limit: limit.toString(),
      }).toString();
      const r = await fetch(
        `${process.env.REACT_APP_API_HOST}/explorer/namesearch?${params}`,
        {
          signal: signal,
          method: "GET",
          headers: AuthService.siteletHeaders,
          credentials: "include",
        },
      );
      if (r.ok) {
        const resp = await r.json();

        if (resp?.errors) {
          Toaster.makeToast("Error on query", "error");
        }
        return resp;
      } else if (r.status === 401) {
        // this.UserReset();
      }
    },
    tagSearch: async (
      search_term: string = "",
      limit: number = 50,
      signal?: AbortSignal,
    ): Promise<string[] | undefined> => {
      const params = new URLSearchParams({
        search_term,
        limit: limit.toString(),
      }).toString();
      const r = await fetch(
        `${process.env.REACT_APP_API_HOST}/explorer/tagsearch?${params}`,
        {
          signal: signal,
          method: "GET",
          headers: AuthService.siteletHeaders,
          credentials: "include",
        },
      );
      if (r.ok) {
        const resp = await r.json();

        if (resp?.errors) {
          Toaster.makeToast("Error on query", "error");
        }
        return resp;
      } else if (r.status === 401) {
        // this.UserReset();
      }
    },
  };
}
